<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Acordos</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3">
                <input
                  v-validate="'required'"
                  type="month"
                  class="form-control"
                  v-model="dados.data"
                />
              </div>
              <div class="col-md-7">
                <input
                  style="width: 100%"
                  class="form-control"
                  placeholder="Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter"
                  name="filtro_pesquisa"
                  ref="filtro_pesquisa"
                  type="text"
                  v-model="dados.pesquisa"
                  @keyup.enter="getDataTable"
                />
              </div>
              <div class="col-md-2">
                <button @click="getDataTable" class="btn btn-default btn-block">
                  <i class="fa fa-filter"></i> Filtrar
                </button>
              </div>
            </div>
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width:auto">Vencimento</th>
                      <th style="width:auto">Pessoa</th>
                      <th style="width:auto">Cpf/Cnpj</th>
                      <th style="width:auto">Parcela</th>
                      <th style="width:auto">Valor</th>
                      <th style="width:auto">Situação</th>
                      <th style="width:auto">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in apiData.data" :key="item.id">
                      <td>{{ item.vencimento | dataFormatada }}</td>
                      <td>{{ item.acordo.pessoa.nome_razao }}</td>
                      <td>{{ item.acordo.pessoa.cpf_cnpj }}</td>
                      <td>{{ item.parcela }}/{{ item.acordo.numero_parcelas }}</td>
                      <td>{{ item.valor}}</td>
                      <td>{{ item.situacao }}</td>
                      <td>
                        <button class="btn btn-success" @click="baixarParcela(item.id)" title="Baixar parcela">
                          <i class="fa fa-fw fa-thumbs-o-up"></i>
                        </button>
                        <button class="btn btn-primary" @click="modalAcordoOpen(item)" title="Detalhes do acordo">
                          <i class="fa fa-fw fa-list"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination
                      :limit="5"
                      :data="apiData"
                      v-on:pagination-change-page="getDataTable"
                    >
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->

    <transition v-if="showModalAcordo" name="modal">
      <div class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Agendamentos dessa pessoa</h3>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="box box-primary p-10">
                  <!-- Nav tabs -->
                  <ul class="nav nav-tabs" role="tablist">
                    <li role="presentation" class="active">
                      <a
                        href="#acordo"
                        aria-controls="acordo"
                        role="tab"
                        data-toggle="tab"
                      >Dados do Acordo</a>
                    </li>
                    <li role="presentation">
                      <a
                        href="#agendamento"
                        aria-controls="agendamento"
                        role="tab"
                        data-toggle="tab"
                      >Agendamentos</a>
                    </li>
                  </ul>

                  <div class="box-body">
                    <!-- Tab panes -->
                    <div class="tab-content">
                      <div role="tabpanel" class="tab-pane active" id="acordo">
                        <table
                          v-if="acordoSelecionado"
                          role="grid"
                          class="table table-bordered table-striped"
                        >
                          <thead>
                            <tr role="row">
                              <th style="width:auto">Data Do Acordo</th>
                              <th style="width:auto">Pessoa</th>
                              <th style="width:auto">Cpf/Cnpj</th>
                              <th style="width:auto">Situação</th>
                              <th style="width:auto">Valor Total do Acordo</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="even" role="row">
                              <td>{{ acordoSelecionado.created_at | dataFormatada }}</td>
                              <td>{{ acordoSelecionado.acordo.pessoa.nome_razao }}</td>
                              <td>{{ acordoSelecionado.acordo.pessoa.cpf_cnpj }}</td>
                              <td>{{ acordoSelecionado.acordo.status }}</td>
                              <td>{{ acordoSelecionado.acordo.valor | numberFormat(2,',','.') }}</td>
                            </tr>
                          </tbody>
                        </table>
                        
                        <h4>Parcelas do Acordo</h4>
                        <table
                          v-if="acordoSelecionado"
                          role="grid"
                          class="table table-bordered table-striped"
                        >
                          <thead>
                            <tr role="row">
                              <th style="width:auto">Vencimento</th>
                              <th style="width:auto">Parcela</th>
                              <th style="width:auto">Valor</th>
                              <th style="width:auto">Situação</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="even" role="row" v-for="item in acordoSelecionado.parcelas" :key="item.id">
                              <td>{{ item.vencimento | dataFormatada }}</td>
                              <td>{{ item.parcela }}/{{ item.acordo.numero_parcelas }}</td>
                              <td>{{ item.valor | numberFormat(2,',','.') }}</td>
                              <td>{{ item.situacao }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="row">
                          <div class="col-sm-12 text-center">
                            <button
                                class="btn btn-danger"
                                :disabled="acordoSelecionado.acordo.status == 'CANCELADO' ? true : false"
                                @click="cancelar(acordoSelecionado.acordo.id)"
                              >Cancelar Acordo</button>
                          </div>
                        </div>
                      </div>
                      <div role="tabpanel" class="tab-pane" id="agendamento">
                        <inadimplente-agendamento v-if="acordoSelecionado" :pessoaId="acordoSelecionado.acordo.pessoa_id"></inadimplente-agendamento>
                      </div>
                    </div>
                  </div>
                  <!-- /.box-body -->
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-right" style="float:right">
              <button class="btn btn-default" @click="modalAcordoClose()">
                <i class="fa fa-close"></i> Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import vSelect from "vue-select";
import InadimplenteAgendamento from "../inadimplentes/inadimplenteAgendamento";

export default {
  components: {
    InadimplenteAgendamento,
    vSelect,
  },
  data: () => ({
    showModalAcordo: false,
    acordoSelecionado: {},
    dados: {
      pesquisa: "",
      data: "",
      operadorSelecionado: null,
    },
    operadores: [
      { value: 1, label: "João" },
      { value: 2, label: "José" },
      { value: 3, label: "Andre" },
    ],
    apiData: {},
  }),
  mounted() {
    this.getDataTable();
    this.$nextTick(() => {
      this.$refs.filtro_pesquisa.focus();
    });
  },

  methods: {
    baixarParcela(parcelaId) {
      this.$swal({
        title: "Baixar parcela!",
        text: "Confirma a baixa da parcela?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
           axios
            .post(
              `${this.$store.state.serverURI}/api/acordo/baixar-parcela`,
              {parcelaId: parcelaId},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.$router.push("/cobranca/acordos");
            })
            .catch(error => {
              this.$store.commit("SHOW_ALERT_ERROR");
              console.log(error);
            });
        }
      })
    },
    modalAcordoOpen(item) {
      this.acordoSelecionado = item;
      this.acordoSelecionado.parcelas = this.apiData.data.filter((obj) => {
        return obj.acordo_id === this.acordoSelecionado.acordo.id;
      })
      console.log(this.acordoSelecionado);
      this.showModalAcordo = true;
    },
    modalAcordoClose() {
      this.pessoaId = null;
      this.showModalAcordo = false;
    },
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.dados.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(`${this.$store.state.serverURI}/api/acordo/getAll`, config)
        .then((response) => {
          console.log(response);
          this.apiData = response.data;
        })
        .catch((error) => {
          this.$store.commit("throwException", error);
        });
    },
    cancelar(acordoId) {
      this.$swal({
        title: "Cancelamento de Acordo!",
        text: "Confirma o cancelamento do acordo?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          axios
            .post(
              `${this.$store.state.serverURI}/api/acordo/cancelar`,
              {acordoId: acordoId},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.modalAcordoClose();
              this.getDataTable();
            })
            .catch(error => {
              this.$store.commit("SHOW_ALERT_ERROR");
              console.log(error);
            });
        }
      })
    },
  },
  watch: {
    page: function (val) {
      this.getDataTable();
    },
  },
};
</script>
<style type="css">
.p-10 {
  padding: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-40 {
  margin-top: 40px;
}
.swal2-container.swal2-shown {
    z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// acordos.vue?9ca13760